import { render, staticRenderFns } from "./MallDepartment.vue?vue&type=template&id=3afde41e"
import script from "./MallDepartment.vue?vue&type=script&lang=js"
export * from "./MallDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports